import React from "react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Convert MUI spacing unit to pixels (MUI spacing unit = 8px)
export function spacingToPx(value) {
  if (typeof value === "number") {
    return `${value * 8}px`;
  }
  return value;
}

// Helper function to convert MUI sx prop to style object
export const convertSxToStyle = (sx) => {
  if (!sx) return {};
  const style = {};
  for (const key in sx) {
    if (Object.prototype.hasOwnProperty.call(sx, key)) {
      const value = sx[key];
      // Handle spacing values
      if (
        typeof value === "number" &&
        [
          "p",
          "px",
          "py",
          "pt",
          "pb",
          "pl",
          "pr",
          "m",
          "mx",
          "my",
          "mt",
          "mb",
          "ml",
          "mr",
          "gap",
        ].includes(key)
      ) {
        const cssProp = {
          p: "padding",
          px: ["paddingLeft", "paddingRight"],
          py: ["paddingTop", "paddingBottom"],
          pt: "paddingTop",
          pb: "paddingBottom",
          pl: "paddingLeft",
          pr: "paddingRight",
          m: "margin",
          mx: ["marginLeft", "marginRight"],
          my: ["marginTop", "marginBottom"],
          mt: "marginTop",
          mb: "marginBottom",
          ml: "marginLeft",
          mr: "marginRight",
          gap: "gap",
        }[key];

        if (Array.isArray(cssProp)) {
          cssProp.forEach((prop) => (style[prop] = spacingToPx(value)));
        } else {
          style[cssProp] = spacingToPx(value);
        }
      } else if (key === "bgcolor") {
        // Handle bgcolor - convert theme paths to CSS variables
        if (typeof value === "string" && value.includes(".")) {
          const bgcolorMap = {
            "background.paper": "hsl(var(--card))",
            "background.default": "hsl(var(--background))",
            "background.card": "hsl(var(--card))",
          };
          style.backgroundColor = bgcolorMap[value] || value;
        } else {
          style.backgroundColor = value;
        }
      } else {
        style[key] = value;
      }
    }
  }
  return style;
};

// Hook to detect dark mode by checking document class
export const useIsDarkMode = () => {
  const [isDark, setIsDark] = React.useState(() => {
    if (typeof document !== "undefined") {
      return document.documentElement.classList.contains("dark");
    }
    return false;
  });

  React.useEffect(() => {
    if (typeof document === "undefined") return;

    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.classList.contains("dark"));
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  return isDark ? "dark" : "light";
};
